<!-- Global notifications are handled by NotificationService; no inline alerts here. -->

<!-- Button to toggle the Drawer -->
<button iconStart="@tui.plus" tuiTextfieldSize="s" size="m" tuiButton type="button" appearance="outline"
  [style.background-color]="'var(--tui-background-secondary)'" (click)="openForCreate()"
  [appPermissionDisable]="'Facility Services'" [appPermissionAction]="'create'"
  [appPermissionSubModule]="'Facilities Setup'">
  Create Custom
</button>

<!-- Drawer Component triggered by the button -->
<tui-drawer class="drawer facility-drawer passes-details-drawer" *tuiPopup="open()"
  [style.width]="isMobile ? '100vw' : null">
  <div class="tui-scrollbar" appTextDirection>

    <!-- Main Form -->
    <form [formGroup]="testForm" [style.max-width.rem]="35" tuiForm="m" (ngSubmit)="onSubmit()"
      (keydown)="onKeyDown($event)" (keypress)="onKeyPress($event)">

      <!-- Drawer Header with title and close button -->
      <header class="drawer-header" tuiHeader>
        <h3 tuiTitle>
          <span *ngIf="!isEditMode">Create New Facility</span>
          <span *ngIf="isEditMode">Edit Facility</span>
          <span tuiSubtitle>
            <span *ngIf="!isEditMode">Add a custom service or utility for this parking location such as valet, helmet
              lockers, EV charging, or car wash. Configure pricing, capacity, and visibility to fit your
              operations.</span>
            <span *ngIf="isEditMode">Modify the facility details, pricing, and settings. All changes will be applied
              immediately.</span>
          </span>
        </h3>
        <button tuiIconButton tuiButtonClose type="button" (click)="closeDrawer()">
          Close
        </button>
      </header>

      <div *ngIf="submitError()" style="margin-bottom: 1rem;">
        <tui-notification appearance="negative" icon="@tui.circle-alert" (close)="submitError.set(null)">
          {{ submitError() }}
        </tui-notification>
      </div>



      <!-- Plan Name Input -->
      <tui-textfield>
        <label tuiLabel>Facility Name*</label>
        <input formControlName="nameValue" tuiTextfield
          [readOnly]="isEditMode || isNameFieldReadonly() || isFromExistingService()" (blur)="onNameFieldBlur()" />
      </tui-textfield>
      <tui-error *ngIf="getErrorMessage('nameValue')" [error]="getErrorMessage('nameValue')" />

      <!-- Description Textarea -->
      <tui-textarea size="s" formControlName="descriptionValue"> Facility Description* </tui-textarea>
      <tui-error *ngIf="getErrorMessage('descriptionValue')" [error]="getErrorMessage('descriptionValue')" />




      <!-- <fieldset>
        <div class="stack">
          <tui-textfield>
            <label tuiLabel>Location*</label>
            <input formControlName="locationValue" tuiTextfield class="custom-small-input" />
          </tui-textfield>
          <tui-error *ngIf="getErrorMessage('locationValue')" [error]="getErrorMessage('locationValue')" />
        </div>
      </fieldset> -->


      <!-- Start Date and End Date Fields -->
      <fieldset>
        <div class="stack">
          <tui-textfield>
            <label tuiLabel>Start Date</label>
            <input formControlName="startDate" tuiInputDate [min]="restrictPastDates && !isEditMode ? minDate : null" />
            <tui-calendar *tuiTextfieldDropdown />
          </tui-textfield>
        </div>
        <div class="stack">
          <tui-textfield>
            <label tuiLabel>End Date</label>
            <input formControlName="endDate" tuiInputDate [min]="minEndDate()" />
            <tui-calendar *tuiTextfieldDropdown />
          </tui-textfield>
        </div>
      </fieldset>


      <fieldset>
        <div class="stack">
          <tui-textfield>
            <label tuiLabel>Capacity Limit</label>
            <input formControlName="capacityValue" tuiTextfield class="custom-small-input" type="text"
              inputmode="numeric" pattern="[0-9]*" (input)="onOnlyNumbersInput($event, 'capacityValue')"
              (keypress)="onlyNumbers($event)" />
          </tui-textfield>
          <tui-error *ngIf="getErrorMessage('capacityValue')" [error]="getErrorMessage('capacityValue')" />
        </div>
        <div class="stack">
          <!-- Status -->
          <tui-textfield tuiChevron [tuiTextfieldCleaner]="false">
            <label tuiLabel>Status*</label>
            <input formControlName="statusValue" tuiSelect placeholder="Choose" />
            <tui-data-list-wrapper *tuiTextfieldDropdown new [items]="statusVehicle" />
          </tui-textfield>
          <tui-error *ngIf="getErrorMessage('statusValue')" [error]="getErrorMessage('statusValue')" />
        </div>
      </fieldset>

      <tui-textfield multi tuiChevron [disabledItemHandler]="strings" [stringify]="stringifyTax"
        [identityMatcher]="taxIdentityMatcher">
        <label tuiLabel>Choose Tax</label>
        <input tuiInputChip [placeholder]="selectedTaxes.length ? '' : 'Select taxes'" [(ngModel)]="selectedTaxes"
          (ngModelChange)="ngModelChangeForTaxes($event)" [ngModelOptions]="{standalone: true}" />
        <tui-input-chip *tuiItem />
        <tui-data-list *tuiTextfieldDropdown>
          <button *ngFor="let tax of allTaxes" tuiOption [value]="tax">
            {{ stringifyTax(tax) }}
          </button>
        </tui-data-list>
      </tui-textfield>

      <!-- choose plan -->
      <tui-textfield tuiChevron [tuiTextfieldCleaner]="false">
        <label tuiLabel>Pricing Type*</label>
        <input formControlName="subPlanValue" tuiSelect placeholder="Choose" />
        <!-- [readOnly]="isFromExistingService()" -->
        <tui-data-list-wrapper *tuiTextfieldDropdown new [items]="subPlan" />
      </tui-textfield>
      <small class="input-des" *ngIf="testForm.get('subPlanValue')?.value && currentUnitTypeDescription().length > 0">
        <ul>
          <li *ngFor="let description of currentUnitTypeDescription()">{{ description }}</li>
        </ul>
      </small>
      <tui-error *ngIf="getErrorMessage('subPlanValue')" [error]="getErrorMessage('subPlanValue')" />


      <!-- Session Based Toggle -->
      <label tuiCell size="m" style="background-color: var(--tui-background-neutral-1); border-radius: 0.75rem;"
        [style.margin-top.rem]="0.25">
        <div tuiTitle>
          <div class="flex small-text"
            style="font: var(--tui-font-text-ui-s); gap: 0rem; flex-direction: column; align-items: flex-start;">
            <div style="display: flex; gap: 0.25rem;">
              <span>Service Flow:</span> &nbsp;<b>{{ sessionBasedStatusText() }}</b>
            </div>
          </div>
        </div>

        <div class="flex items-center" [style.gap.rem]="0.5" style="font: var(--tui-font-text-ui-s);">
          <span [style.color]="'var(--tui-text-secondary)'">{{ sessionBasedYesNoText() }}</span>
          <input tuiSwitch type="checkbox" [formControl]="testForm.controls.isSessionBasedValue" />
        </div>
      </label>
      <div style="font: var(--tui-font-text-ui-s); color: var(--tui-text-secondary); margin-top: -0.8rem;">
        {{ sessionBasedDescriptionText() }}
        <a tuiLink [href]="sessionBasedKnowMoreUrl()" target="_blank" rel="noopener noreferrer"
          [style.text-decoration-line]="'underline'">Know more</a>
      </div>

      <!-- Notes Section -->
      <app-input-heading heading="NOTES" [style.margin-top.rem]="0.25" />
      <ul>
        <li>This service will be visible in your selected parking only.</li>
        <li>Choose a name that’s clear to your operators and customers (e.g., “EV Charger – Fast Port” or “Helmet
          Locker”).</li>
        <li>Add images to make this facility easily recognizable across devices.</li>
        <li>You can set a capacity limit if the facility has restricted availability (e.g., 2 valet staff, 6 lockers).
        </li>
        <li>You can edit or disable the service later from your parking settings.</li>
      </ul>

    </form>
  </div>

  <!-- Drawer Footer with Action Buttons -->
  <footer style="display: flex; justify-content: flex-end; gap: 1rem; padding: 1rem;">
    <button appearance="text" size="m" tuiButton type="button" (click)="closeDrawer()"
      [disabled]="submissionStatus() === 'submitting'">Cancel</button>
    <button appearance="primary" size="m" tuiButton type="button" (click)="onSubmit()"
      [disabled]="submissionStatus() === 'submitting' || submissionStatus() === 'success'"
      [iconStart]="submissionStatus() === 'submitting' ? '@tui.loader' : undefined">
      <span *ngIf="submissionStatus() === 'submitting'">Saving...</span>
      <span *ngIf="submissionStatus() === 'success'">
        <span *ngIf="!isEditMode">Created</span>
        <span *ngIf="isEditMode">Updated</span>
      </span>
      <span *ngIf="submissionStatus() !== 'success' && submissionStatus() !== 'submitting'">
        <span *ngIf="!isEditMode">Create</span>
        <span *ngIf="isEditMode">Update</span>
      </span>
    </button>
  </footer>
</tui-drawer>